export const setConversationAction = (state, action) => {
  Object.assign(state, action.payload);
};
